import { motion } from "framer-motion";
import { Dumbbell, CalendarRange, MessageSquareText, HeartPulse, Pill, ClipboardList } from "lucide-react";

const FEATURES = [
  { icon: Dumbbell, title: "4-Day Upper/Lower Hypertrophy Split", text: "Optimal frequency for size. Hit every muscle twice a week with surgical precision." },
  { icon: CalendarRange, title: "8-Week Progressive Overload Cycle", text: "A planned progression path — no guessing what to lift, ever." },
  { icon: MessageSquareText, title: "Detailed Coaching Cues", text: "Every exercise comes with execution cues so you feel the target muscle work, not your ego." },
  { icon: HeartPulse, title: "Active Recovery & Core Workouts", text: "Off-day protocols that build your core and speed up recovery instead of wasting it." },
  { icon: Pill, title: "Evidence-Based Supplement Guide", text: "Only what works. Save your money on the rest of the snake oil." },
  { icon: ClipboardList, title: "Progressive Overload Tracking Log", text: "A ready-to-use log to track every set, rep and PR across the full cycle." },
];

export const ProgramBreakdown = () => {
  return (
    <section id="features" className="py-24 sm:py-32 bg-[#0A0A0A] border-y border-[#2A2A2A] relative">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(circle at 20% 80%, rgba(57,255,20,0.06) 0%, transparent 50%)" }}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative">
        <p className="section-label mb-4">// WHAT'S INSIDE //</p>
        <h2 className="font-anton text-4xl sm:text-5xl uppercase tracking-tight mb-16">
          Everything you need. <span className="neon-text">Nothing you don't.</span>
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#2A2A2A] border border-[#2A2A2A]">
          {FEATURES.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="bg-[#0A0A0A] p-8 hover:bg-[#111111] transition-colors"
              data-testid={`feature-card-${i}`}
            >
              <div className="flex items-center gap-3 mb-4">
                <f.icon size={22} className="text-[#39FF14]" />
                <span className="font-jet text-[10px] text-[#52525B] tracking-widest">0{i + 1}</span>
              </div>
              <h3 className="font-bebas text-xl tracking-[0.08em] mb-3">{f.title}</h3>
              <p className="text-[#A1A1AA] text-sm leading-relaxed">{f.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
